const PROVIDER_KEYS = {
  FACEBOOK: "socialProviderFacebook",
  GOOGLE: "socialProviderGoogle",
  APPLE: "socialProviderApple",
};

const readErrorText = (error) =>
  [
    error?.code,
    error?.message,
    error?.response?.data?.code,
    error?.response?.data?.error,
    error?.response?.data?.message,
  ]
    .filter((value) => typeof value === "string")
    .join(" ")
    .toLowerCase();

export const getSocialAuthFeedback = (provider, error, outcome) => {
  const normalizedProvider = String(provider || "").toUpperCase();
  const providerKey = PROVIDER_KEYS[normalizedProvider] || "socialProviderAccount";
  const searchable = readErrorText(error);
  let messageKey = "socialLoginFailed";
  let success;

  if (outcome === "success") {
    messageKey = "socialLoginSuccess";
    success = true;
  } else if (
    outcome === "cancelled" ||
    searchable.includes("cancel") ||
    searchable.includes("popup-closed")
  ) {
    messageKey = "socialLoginCancelled";
  } else if (
    searchable.includes("permission") ||
    searchable.includes("access_denied") ||
    searchable.includes("access-denied") ||
    searchable.includes("consent")
  ) {
    messageKey = "socialPermissionDenied";
    success = false;
  } else if (searchable.includes("account-exists-with-different-credential")) {
    messageKey = "socialDifferentConnectionMethod";
    success = false;
  } else if (searchable.includes("user-disabled")) {
    messageKey = "socialAccountUnavailable";
    success = false;
  } else if (
    searchable.includes("network") ||
    searchable.includes("timeout") ||
    searchable.includes("temporarily unavailable")
  ) {
    messageKey = "socialNetworkError";
    success = false;
  } else if (
    searchable.includes("operation-not-allowed") ||
    searchable.includes("unauthorized-domain") ||
    searchable.includes("invalid-credential") ||
    searchable.includes("configuration")
  ) {
    messageKey = "socialLoginUnavailable";
    success = false;
  } else {
    success = false;
  }

  return {providerKey, messageKey, success};
};

export const getSocialAuthToast = (t, provider, error, outcome) => {
  const feedback = getSocialAuthFeedback(provider, error, outcome);
  const providerName = t(feedback.providerKey);
  return {
    success: feedback.success,
    title: t("socialConnectionTitle", {provider: providerName}),
    message: t(feedback.messageKey, {provider: providerName}),
  };
};
